import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import Link from '../../utils/link';

import {
  NavLabel,
  NavLink,
  NavNoLink,
  NoChildrenLabel,
  NoChildrenViewAll,
  SecondaryItem,
  SecondaryList,
  SecondaryTrigger
} from './styles';

import { getNavigationProps, getNavigation } from '../../utils/navigation';
import { trackNavigationClick } from '../../utils/tracking';

const NavigationNoChildren = (props) => {
  const [nav2] = useState(getNavigation(props.navigation, 2));
  const [parent] = useState(props.parent);
  return (
    nav2 && parent
      ? (
        <SecondaryList role="menu" noChildren>
          <NoChildrenLabel noChildrenLabel>
            <Link
              {...getNavigationProps({ item: parent })}
              passHref
            >
              <NavLink onClick={() => trackNavigationClick(parent)}>
                {parent.name}
              </NavLink>
            </Link>
          </NoChildrenLabel>

          <SecondaryItem role="menuitem" viewAll>
            <Link
              {...getNavigationProps({ item: parent, viewAll: true })}
              passHref
            >
              <NavLink>View All</NavLink>
            </Link>
          </SecondaryItem>

          {
              nav2.filter((x) => x.parent_id === parent.id).map((item) => (
                item.has_children
                  ? (
                    <SecondaryItem role="menuitem" key={item.id}>
                      <SecondaryTrigger
                        onChange={(e) => props.handleChange(e, item)}
                        type="checkbox"
                        id={item.id}
                        name="secondary"
                      />
                      <NavLabel htmlFor={item.id}>{item.name}</NavLabel>

                      {
                        item.header_link
                          ? (
                            <Link
                              {...getNavigationProps({ item })}
                              passHref
                            >
                              <NavLink onClick={() => trackNavigationClick(item)}>
                                {item.name}
                              </NavLink>
                            </Link>
                          ) : (
                            <NavNoLink onClick={() => trackNavigationClick(item)}>
                              {item.name}
                            </NavNoLink>
                          )
                      }

                      { props.renderTertiary(item) }
                    </SecondaryItem>
                  )
                  : (
                    <SecondaryItem role="menuitem" key={item.id}>
                      <Link
                        {...getNavigationProps({ item })}
                        passHref
                      >
                        <NavLink onClick={() => trackNavigationClick(item)}>
                          {item.name}
                        </NavLink>
                      </Link>
                    </SecondaryItem>
                  )
              ))
          }

          <NoChildrenViewAll role="menuitem">
            <Link
              {...getNavigationProps({ item: parent, viewAll: true })}
              passHref
            >
              <NavLink onClick={() => trackNavigationClick(parent)}>
                View All
              </NavLink>
            </Link>
          </NoChildrenViewAll>
        </SecondaryList>
      ) : null
  );
};

NavigationNoChildren.propTypes = {
  handleChange: PropTypes.func.isRequired,
  navigation: PropTypes.object.isRequired,
  parent: PropTypes.object.isRequired,
  renderTertiary: PropTypes.func.isRequired
};

export default memo(NavigationNoChildren);
